import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import {
  getDepartmentList,
  getPositionList,
  syncGenarateToken,
} from "../../../Services/SsoService";
import SyncListSkeleton from "../../../components/loader/SyncListSkeleton";
import Select from "../../form/Select";
import Button from "../../form/Button";
import { Tooltip } from "react-tooltip";
import Loader from "../../../components/loader/Loader";
import SyncingLoader from "../../../components/loader/SyncingLoader";
import CustomPagination from "../../../components/elements/CustomPagination";
import {
  ORGCHART_API_URL,
  ORGCHART_BASE_URL,
  SUCCESSION_API_URL,
  SUCCESSION_BASE_URL,
} from "../../../config/host";
import { toast } from "react-toastify";
import Checkbox from "../../form/Checkbox";
import moment from "moment";

const DepartmentList = ({
  syncingStep,
  syncFailed,
  syncSuccess,
  selectedDepartment,
  setSelectedDepartment = () => {},
  areDepartmentAllSelected,
  setAreDepartmentAllSelected = () => {},
  syncDataModalOpen,
  userData,
}) => {
  const [departmentList, setDepartmentList] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [startDataCount, setStartDataCount] = useState(0);
  const [endDataCount, setEndDataCount] = useState(0);
  const [noOfPage, setNoOfPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);

  const loadList = useCallback(async () => {
    setLoadingData(true);
    try {
      const result = await getDepartmentList({
        keyword: keyword,
        limit: limit,
        offset: offset,
        keyword: keyword,
        companyId: userData?.companyDetails?._id,
      });
      if (result.status === 200) {
        setDepartmentList(result?.data);
      }
      setTotalDataCount(result?.totalDocs);
      setPageCount(result?.totalPages);
      setLoadingData(false);
    } catch (err) {
      setLoadingData(false);
      toast.error(err.message || "Somthing went wrong");
    } finally {
      setLoadingData(false);
    }
  }, [keyword, limit, offset, userData]);

  useEffect(() => {
    loadList();
  }, [loadList]);

  useEffect(() => {
    setNoOfPage(Math.ceil(totalDataCount / limit));
    const startItem = Number(totalDataCount > 0 ? 1 : 0);
    const endItem = Math.min(startItem + limit - 1, totalDataCount);
    setStartDataCount(startItem);
    setEndDataCount(endItem);
    if (keyword) {
      setOffset(0);
    }
  }, [limit, totalDataCount, keyword]);

  const handleSelectedDepartment = (item) => {
    setSelectedDepartment((prevSelected) => {
      const isAlreadySelected = prevSelected.some(
        (member) => member?._id === item?._id
      );

      if (isAlreadySelected) {
        return prevSelected.filter((member) => member?._id !== item?._id);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handleSelectAll = () => {
    const filteredMembers =
      departmentList &&
      Array.isArray(departmentList) &&
      departmentList?.length > 0 &&
      departmentList?.filter((member) => member._id);

    if (selectedDepartment.length === filteredMembers.length) {
      setSelectedDepartment([]);
    } else {
      setSelectedDepartment(filteredMembers);
    }
  };

  useEffect(() => {
    if (syncDataModalOpen) {
      const filteredMembers =
        departmentList &&
        Array.isArray(departmentList) &&
        departmentList?.length > 0 &&
        departmentList?.filter((member) => member?._id);
      const isAllSelected =
        selectedDepartment?.length === filteredMembers?.length &&
        filteredMembers?.length !== 0;

      if (isAllSelected) {
        setAreDepartmentAllSelected(true);
      } else {
        setAreDepartmentAllSelected(false);
      }
    }
  }, [
    areDepartmentAllSelected,
    departmentList,
    selectedDepartment,
    syncDataModalOpen,
  ]);

  const syncPosition = async (url, headersToken) => {
    const updatedDepartmentList =
      departmentList &&
      Array.isArray(departmentList) &&
      departmentList?.length > 0 &&
      departmentList.map((item) => {
        const isSelected = selectedDepartment.some(
          (member) => member._id === item._id
        );
        if (isSelected) {
          return { ...item, syncingStatus: "processing" };
        }
        return item;
      });
    setDepartmentList(updatedDepartmentList);
    try {
      while (selectedDepartment.length > 0) {
        const currentDepartment = selectedDepartment[0];

        // Validate currentEmployee fields
        if (!currentDepartment || !currentDepartment.title) {
          toast.error("Invalid position data encountered.");
          selectedDepartment.shift();
          continue;
        }

        const path = url;
        const payload = {
          // companyEmail: currentPosition.company_info?.email,
          companyEmail: "sujaymondal50@gmail.com",
          department_details: {
            name: currentDepartment?.title,
            short_name: currentDepartment?.short_name,
          },
          code: "9boxNow",
        };

        try {
          const res = await axios.post(path, payload, {
            headers: {
              Authorization: `Bearer ${headersToken}`,
              "Content-Type": "application/json",
            },
          });

          if (res?.data?.status === 200) {
            // toastr.success(`Successfully synced: ${currentEmployee.name}`);
            setDepartmentList((prevList) =>
              prevList.map((item) =>
                item._id === currentDepartment._id
                  ? { ...item, syncingStatus: "success" }
                  : item
              )
            );
            selectedDepartment.shift(); // Remove the synced employee from the list
          } else {
            setDepartmentList((prevList) =>
              prevList.map((item) =>
                item._id === currentDepartment._id
                  ? { ...item, syncingStatus: "failed" }
                  : item
              )
            );
            selectedDepartment.shift();
            // break; // Stop processing further employees
          }
        } catch (err) {
          console.error(
            `Error syncing employee: ${currentDepartment.title}`,
            err
          );
          setDepartmentList((prevList) =>
            prevList.map((item) =>
              item._id === currentDepartment._id
                ? { ...item, syncingStatus: "failed" }
                : item
            )
          );
          if (err.response) {
            console.error("Server error:", err.response.data);
            toast.error(
              `Error: ${err.response.data.message || "Server error occurred."}`
            );
          } else if (err.request) {
            // Request was made but no response received
            console.error("No response received:", err.request);
            toast.error("Network error. Please try again later.");
          } else {
            console.error("Unexpected error:", err.message);
            toast.error(`Unexpected error: ${err.message}`);
          }

          selectedDepartment.shift();
          // break;
        }
      }
    } catch (err) {
      toast.error("A critical error occurred. Please try again later.");
    }
  };

  const getGenarateTokenForPosition = async (DOMAIN, API_URL = "") => {
    try {
      const res = await syncGenarateToken({
        domain: DOMAIN,
      });
      if (res?.status === 200) {
        const url = API_URL + "sync-position";
        const headersToken = res?.data;
        syncPosition(url, headersToken);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      toast.error(err.message || "Somthing went wrong !!!");
    }
  };

  return (
    <>
      {loadingData && <SyncListSkeleton type={"position"} count={10} />}
      {!loadingData && (
        <>
          <div className="flex-shrink flex-grow">
            <div className="relative flex gap-3 items-center mb-3 flex-wrap mt-2">
              <div className="relative">
                <Select
                  selectedValue={limit}
                  dropdownClass={"w-auto"}
                  dropdownData={[
                    {
                      name: "All Items",
                      value: totalDataCount,
                    },
                    { name: "5 Items", value: 5 },
                    { name: "10 Items", value: 10 },
                    { name: "20 Items", value: 20 },
                    { name: "30 Items", value: 30 },
                    { name: "50 Items", value: 50 },
                    { name: "100 Items", value: 100 },
                  ]}
                  getSelectedValue={(e) => {
                    setLimit(e.value);
                    setOffset(0);
                    setCurrentPage(0);
                    setSelectedDepartment([]);
                  }}
                />
              </div>
              {selectedDepartment?.length > 0 && (
                <div className="relative">
                  <h1 className="font-semibold">
                    <span className="text-sm text-gray-500">
                      {selectedDepartment.length} Employee
                      {selectedDepartment.length > 1 ? "s" : ""} Selected
                    </span>
                  </h1>
                </div>
              )}
              {departmentList &&
                Array.isArray(departmentList) &&
                departmentList?.length > 0 &&
                departmentList?.filter((member) => member?._id).length > 0 && (
                  <div
                    className="ml-auto"
                    data-tooltip-id={`selectAllButton${1434}`}
                    data-tooltip-place="bottom"
                  >
                    <Button
                      buttonType={"button"}
                      buttonClasses={
                        "bg-transparent border border-blue-500 !text-blue-500 ml-2"
                      }
                      buttonLabelClasses="text-blue-500"
                      buttonIcon={
                        areDepartmentAllSelected
                          ? "fa-solid fa-square-check"
                          : "fa-regular fa-square"
                      }
                      buttonIconPosition={"left"}
                      buttonLabel={
                        areDepartmentAllSelected
                          ? "Unselect All Department"
                          : "Select All Department"
                      }
                      buttonHasLink={false}
                      buttonFunction={() => handleSelectAll()}
                    />
                    <Tooltip
                      id={`selectAllButton${1434}`}
                      className="!text-xs z-50 rounded py-3 px-6"
                      render={() => (
                        <div className="gap-x-1">
                          <div className="text-[13px] font-normal leading-none flex items-center">
                            <div className="font-semibold">
                              {areDepartmentAllSelected
                                ? "Unselect All Department"
                                : "Select All Department"}
                            </div>
                          </div>
                        </div>
                      )}
                    />
                  </div>
                )}
              {selectedDepartment?.length > 0 && (
                <div className="ml-auto flex items-center">
                  <Button
                    buttonLabel={"Sync Position"}
                    buttonIcon={"fa-solid fa-rotate"}
                    buttonIconPosition={"left"}
                    buttonClasses={"!bg-blue-500 !text-white"}
                    buttonLabelClasses={"!text-white"}
                    buttonFunction={() => {
                      if (
                        syncingStep?.selectedWebsite?.code === "successionNow"
                      ) {
                        getGenarateTokenForPosition(
                          SUCCESSION_BASE_URL,
                          SUCCESSION_API_URL
                        );
                      } else if (
                        syncingStep?.selectedWebsite?.code === "orgChart"
                      ) {
                        getGenarateTokenForPosition(
                          ORGCHART_BASE_URL,
                          ORGCHART_API_URL
                        );
                      } else {
                        toast.error("Please Select a Website For Syncing");
                      }
                    }}
                  />
                </div>
              )}
            </div>
            <div className="grid grid-cols-2 gap-2 overflow-auto scroll-smooth scrollbar max-h-[calc(100vh-250px)] -mx-4 px-4">
              {departmentList &&
                Array.isArray(departmentList) &&
                departmentList?.length > 0 &&
                departmentList?.map((user, index) => {
                  const alreadySyncingData =
                    Array?.isArray(user?.websiteInfo) &&
                    user?.websiteInfo?.length > 0
                      ? user?.websiteInfo?.filter(
                          (info) =>
                            info.code === syncingStep?.selectedWebsite?.code
                        )[0]
                      : {};
                  return (
                    <>
                      <div className="bg-white rounded-md border border-slate-200 py-4 px-4 flex items-center gap-2 w-full">
                        <div className="flex justify-start flex-shrink-0">
                          <div
                            className="flex items-center justify-between py-2"
                            key={index}
                          >
                            <Checkbox
                              isChecked={selectedDepartment.some(
                                (member) => member?._id === user?._id
                              )}
                              checkboxClass={"!border-blue-500"}
                              onChange={() => handleSelectedDepartment(user)}
                            />
                            {/* <input
                            type="checkbox"
                            id={`${user?._id}`}
                            checked={selectedPosition.some(
                              (member) => member?._id === user?._id
                            )}
                            onChange={() => handleSelectedDepartment(user)}
                            className="border cursor-pointer w-5 h-5 border-slate-400 focus:ring-transparent checked:rounded-full rounded-full checked:text-dark-blue-700   checked:hover:bg-dark-blue-700 checked:bg-dark-blue-700 "
                          /> */}
                          </div>
                        </div>
                        <div className="flex-shrink flex-grow">
                          <h3 className="flex items-center gap-1 text-sm font-semibold text-blue-500 capitalize">
                            {user?.groupName || "N/A"}
                          </h3>
                        </div>
                        {user?.syncingStatus === "processing" && (
                          <div className="flex flex-col items-center ml-auto flex-shrink-0">
                            <Loader className={"scale-50"} />
                            <SyncingLoader className={"!text-xs"} />
                          </div>
                        )}
                        {user?.syncingStatus === "success" && (
                          <div className="flex flex-col items-center ml-auto flex-shrink-0">
                            <div className="w-8 h-8">
                              <img src={syncSuccess} alt="syncSuccess" />
                            </div>
                            <div className="flex text-center justify-center items-center text-xs font-semibold text-green-600">
                              {"Sync Finished"}
                            </div>
                          </div>
                        )}
                        {user?.syncingStatus === "failed" && (
                          <div className="flex flex-col items-center ml-auto flex-shrink-0">
                            <div className="w-8 h-8">
                              <img src={syncFailed} alt="syncFailed" />
                            </div>
                            <div className="flex text-center justify-center items-center text-xs font-semibold text-rose-600">
                              {"Sync Failed"}
                            </div>
                          </div>
                        )}
                        {!user?.syncingStatus &&
                          alreadySyncingData?.code &&
                          alreadySyncingData?.positionId && (
                            <div className="flex flex-col items-end ml-auto flex-shrink-0">
                              <div className="w-8 h-8">
                                <i className="far fa-sync"></i>
                              </div>
                              <div className="flex text-right flex-col justify-center items-end text-[11px] font-semibold text-slate-400 !leading-none">
                                Last Sync
                                <span className="text-slate-500 font-bold">
                                  {moment(alreadySyncingData?.updatedAt).format(
                                    "ll"
                                  )}
                                </span>
                              </div>
                            </div>
                          )}
                      </div>
                    </>
                  );
                })}
            </div>
          </div>
          <CustomPagination
            paginationClasses={"mt-5 justify-end"}
            onPageChange={(val) => {
              setOffset(limit * val?.selected);
              setCurrentPage(val?.selected);
              setSelectedDepartment([]);
            }}
            pageCount={pageCount}
            currentPage={currentPage}
          />
        </>
      )}
    </>
  );
};

export default DepartmentList;
